import { EventEmitter, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';  
import { CoreServiceService } from '../core/core-service.service';
import { LiveEvent } from '../Models/live-event';
@Injectable({
  providedIn: 'root'
})
export class LiveEventsService {
  messageReceived = new EventEmitter<LiveEvent>();  
  connectionEstablished = new EventEmitter<Boolean>();  
  
  private connectionIsEstablished = false;  
  private _hubConnection: HubConnection;  
  
  private BaseApiPath:string;
  constructor(private coreService:CoreServiceService) { 

    this.BaseApiPath=this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath; 
  

     
  }  
  Start()
  {
    this.createConnection();  
    this.registerOnServerEvents();  
    this.startConnection();
    this._hubConnection.onclose((err)=>{

      this.connectionEstablished.emit(false);
       
    }) 
  }
  Stop()
  {
    if(this._hubConnection)
    {
      this._hubConnection.stop().then(()=>{

        console.log("Hub Connection Closed");
        
      });
      
    }
  }
  sendMessage(eventType: LiveEvent) {  
    this._hubConnection.invoke('SendMessage', eventType);  
  }  
  
  private createConnection() {  
    this._hubConnection = new HubConnectionBuilder()  
      .withUrl( this.BaseApiPath+ 'liveEventHub')  
      .build();  
  }  
  
  private startConnection(): void {  
    this._hubConnection  
      .start()  
      .then(() => {  
        this.connectionIsEstablished = true;  
        console.log('Hub connection started');  
        this.connectionEstablished.emit(true);  
      })  
      .catch(err => {  
        console.log('Error while establishing connection, retrying...');  
        setTimeout(function () { this.startConnection(); }, 5000);  
      });  
  }  
  
  private registerOnServerEvents(): void {  
    this._hubConnection.on('ReceiveMessage', (data: any) => {  
      this.messageReceived.emit(data);  
    });  
  }   
}
